<template lang="pug">
.app-file-import
  label.control-label(v-if="showLabel") {{ label }}
    i.hi.hi-12.hi-info-filled.a-tooltip.text-lighter.d-flex.align-items-center.ml-5(
      v-if="showLabel && showFileTypesOnLabel"
      v-tooltip="{ placement: 'top' }"
      data-toggle="tooltip"
      data-placement="top"
      :data-original-title="tooltipText"
    )
  .upload-zone(
    v-loading="loading"
    @drop.prevent="addFile"
    @dragover.prevent=""
  )
    .upload-text(v-if="!hasAttachment")
      .upload-field
        label.btn.btn-outline-primary.text-blue
          | Browse files
          AppFilePicker.upload(
            ref="filePicker"
            name="upload"
            :accept="mimeTypes"
            data-testid="file-upload-input"
            @input="onStartUploading"
          )
    .uploaded-file(v-else)
      i.hi.hi-14.hi-delete-xs.clickable(
data-testid="file-delete-icon"
@click="deleteFile")
      .filename(data-testid="file-filename") {{ fileName }}
      .download-file(v-if="downloadFileUrl")
        a.d-flex.justify-content-center.ml-5(
:href="downloadFileUrl"
data-testid="file-download-link")
          i.hi.hi-12.hi-export
    .accepted-file-types(v-if="!showFileTypesOnLabel")
      | Accepted file formats:&nbsp;
      span.file-types {{ fileTypes }}
  a.template-download(
    v-if="templateUrl"
    :href="templateUrl"
    download
  ) Download the template here
  a.template-download(
    v-if="templateEvent"
    href=""
    download
    @click.prevent="$emit('download-template')"
  ) Download the template here
  slot
  .d-flex.justify-content-end.gap-15.mt-30(v-if="importFile")
    AppButton(@click="close") Cancel
    AppButton(
      type="primary"
      :disabled="!hasAttachment"
      @click="onImport"
    ) Import
</template>

<script>
import { FileImportsResource } from '~/resources';
import { get } from 'lodash-es';

export default {
  name: 'AppFileImport',
  props: {
    fileTypes: {
      type: String,
      required: true,
    },
    fileParams: {
      type: Object,
      required: true,
    },
    label: {
      type: String,
      default: 'File',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    mimeTypes: {
      type: String,
      required: true,
    },
    organizationId: {
      type: Number,
      default: 0,
    },
    resourceType: {
      type: String,
      default: '',
    },
    subType: {
      type: String,
      required: false,
      default: '',
    },
    // href for link "Download the template here"
    templateUrl: {
      type: String,
      default: '',
    },
    // $emit('download-template') for link "Download the template here"
    templateEvent: {
      type: Boolean,
      default: false,
    },
    importConfig: {
      type: Object,
      default: () => {},
    },
    importFile: {
      type: Boolean,
      default: true,
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    showFileTypesOnLabel: {
      type: Boolean,
      default: false,
    },
    downloadFileUrl: {
      type: String,
      default: null,
    },
    autoClose: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    hasAttachment() {
      return !!this.fileParams.id;
    },
    fileName() {
      return get(this.fileParams, 'metadata.filename');
    },
    tooltipText() {
      return `Accepted file formats: ${this.fileTypes}`;
    },
  },
  methods: {
    close() {
      this.$emit('close');
      this.setLoading(false);
    },
    onImport() {
      this.setLoading(true);

      return FileImportsResource.create(
        {},
        {
          organization_id: this.organizationId,
          file_import: { resource_type: this.resourceType, file: this.fileParams, config: this.importConfig },
        },
      )
        .then((response) => {
          response.alert && this.$appMessage(response.alert);
          this.$emit('import-success', response);
          if (this.autoClose) {
            this.close();
          }
        })
        .catch((error) => {
          this.$appMessage(error.responseJSON.alert);
        })
        .finally(() => {
          this.setLoading(false);
        });
    },
    addFile(event) {
      const droppedFiles = event.dataTransfer.files;

      if (droppedFiles && droppedFiles.length === 1) {
        this.onStartUploading(droppedFiles[0]);
      } else {
        this.$appMessage('Please drag only one file.');
      }
    },
    onStartUploading(file) {
      this.$emit('upload-file', file);
    },
    deleteFile() {
      if (confirm('Are you sure you want to remove this file?')) {
        this.$emit('remove-file');
      }
    },
    setLoading(val) {
      this.$emit('is-loading', val);
    },
  },
};
</script>
